/*
 * Soluciones Vida AmaGa - Recuperacion del carrito Shrine PRO 1.0.1
 * Fecha: 2026-08-28
 * Version: 3 (carrito lateral + descuentos mediante Cart AJAX API)
 *
 * Este archivo reemplaza las funciones esenciales que dejaron de cargarse
 * porque assets/shrine.null.js esta truncado. No depende del codigo ofuscado.
 */

(() => {
  'use strict';

  const ROOT = window.Shopify?.routes?.root || '/';
  const ROUTES = {
    add: window.routes?.cart_add_url || `${ROOT}cart/add.js`,
    change: window.routes?.cart_change_url || `${ROOT}cart/change.js`,
    update: window.routes?.cart_update_url || `${ROOT}cart/update.js`,
    cart: window.routes?.cart_url || `${ROOT}cart`,
  };

  const CART_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  const FOCUSABLE_SELECTOR = [
    'summary',
    'a[href]',
    'button:not([disabled])',
    '[tabindex]:not([tabindex^="-"])',
    'input:not([type="hidden"]):not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
  ].join(',');

  let focusTrap = null;

  if (typeof window.debounce !== 'function') {
    window.debounce = (callback, wait = 300) => {
      let timeout;
      return (...args) => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => callback.apply(null, args), wait);
      };
    };
  }

  if (typeof window.fetchConfig !== 'function') {
    window.fetchConfig = (type = 'json') => ({
      method: 'POST',
      headers: {
        Accept: `application/${type}`,
        'Content-Type': 'application/json',
      },
    });
  }

  if (typeof window.getFocusableElements !== 'function') {
    window.getFocusableElements = (container) =>
      Array.from(container?.querySelectorAll(FOCUSABLE_SELECTOR) || []).filter(
        (element) => !element.hasAttribute('disabled') && element.getAttribute('aria-hidden') !== 'true'
      );
  }

  if (typeof window.removeTrapFocus !== 'function') {
    window.removeTrapFocus = (elementToFocus = null) => {
      if (focusTrap) {
        document.removeEventListener('focusin', focusTrap.onFocusIn);
        document.removeEventListener('keydown', focusTrap.onKeyDown);
        focusTrap = null;
      }

      if (elementToFocus && typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      }
    };
  }

  if (typeof window.trapFocus !== 'function') {
    window.trapFocus = (container, elementToFocus = container) => {
      if (!container) return;

      window.removeTrapFocus();
      const focusable = window.getFocusableElements(container);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      const onFocusIn = (event) => {
        if (event.target !== container && event.target !== first && event.target !== last) return;

        document.addEventListener('keydown', onKeyDown);
      };

      const onKeyDown = (event) => {
        if (event.code !== 'Tab') return;

        if (event.shiftKey && (event.target === first || event.target === container)) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && event.target === last) {
          event.preventDefault();
          first?.focus();
        }
      };

      focusTrap = { onFocusIn, onKeyDown };
      document.addEventListener('focusin', onFocusIn);
      document.addEventListener('keydown', onKeyDown);

      window.setTimeout(() => {
        (elementToFocus || first || container)?.focus?.();
      });
    };
  }

  if (typeof window.pauseAllMedia !== 'function') {
    window.pauseAllMedia = () => {
      document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow?.postMessage(
          JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }),
          '*'
        );
      });

      document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), '*');
      });

      document.querySelectorAll('video').forEach((video) => video.pause());
      document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause?.());
    };
  }

  const cartContainsDiscount = (cart, code) => {
    const normalizedCode = code.trim().toLocaleLowerCase();
    const applications = [...(cart.cart_level_discount_applications || [])];

    (cart.items || []).forEach((item) => {
      (item.discount_allocations || []).forEach((allocation) => {
        if (allocation.discount_application) applications.push(allocation.discount_application);
      });
    });

    return applications.some((application) => {
      const discount = application.discount_application || application;
      const candidates = [discount.code, discount.title, discount.description]
        .filter(Boolean)
        .map((value) => String(value).trim().toLocaleLowerCase());

      return candidates.includes(normalizedCode);
    });
  };

  const showDiscountError = (form, message) => {
    const error = form?.querySelector('.cart-discount-form__error');
    if (!error) return;

    error.textContent = message;
    error.style.color = '';
    error.style.display = 'block';
  };

  const showDiscountSuccess = (form, message) => {
    const status = form?.querySelector('.cart-discount-form__error');
    if (!status) return;

    status.textContent = message;
    status.style.color = '#2f7d32';
    status.style.display = 'block';
    status.setAttribute('role', 'status');
  };

  if (typeof window.handleDiscountFormChange !== 'function') {
    window.handleDiscountFormChange = () => {
      document.querySelectorAll('.cart-discount-form__error').forEach((error) => {
        error.style.display = 'none';
        error.style.color = '';
      });
    };
  }

  if (typeof window.handleDiscountForm !== 'function') {
    window.handleDiscountForm = async (event) => {
      event.preventDefault();

      const form = event.currentTarget || event.target;
      const field = form.querySelector('[name="cart-discount-field"]');
      const button = form.querySelector('button[type="submit"]');
      const code = field?.value?.trim() || '';

      window.handleDiscountFormChange();

      if (!code) {
        showDiscountError(form, 'Ingresa un código de descuento.');
        field?.focus();
        return;
      }

      form.setAttribute('aria-busy', 'true');
      if (button) button.disabled = true;

      try {
        const response = await fetch(ROUTES.update, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            discount: code,
            sections: CART_SECTIONS,
            sections_url: window.location.pathname,
          }),
        });

        const cart = await response.json();
        if (!response.ok || cart.status) {
          throw new Error(cart.description || cart.message || 'No fue posible aplicar el código de descuento.');
        }

        const drawer = document.querySelector('cart-drawer');
        if (drawer?.renderContents) {
          drawer.renderContents(cart, true);
        }

        const refreshedForm = document.querySelector('cart-drawer .cart-discount-form') || form;
        const refreshedField = refreshedForm.querySelector('[name="cart-discount-field"]');
        if (refreshedField) refreshedField.value = code;

        if (!cartContainsDiscount(cart, code)) {
          showDiscountError(refreshedForm, 'El código no es válido o no aplica a este carrito.');
        } else {
          showDiscountSuccess(refreshedForm, `Código ${code} aplicado correctamente.`);
        }
      } catch (error) {
        const activeForm = document.querySelector('cart-drawer .cart-discount-form') || form;
        showDiscountError(activeForm, error.message || 'No fue posible aplicar el código de descuento.');
      } finally {
        form.removeAttribute('aria-busy');
        if (button) button.disabled = false;
      }
    };
  }

  if (!customElements.get('quantity-input')) {
    class QuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input[type="number"]');
        this.addEventListener('click', this.onButtonClick.bind(this));
      }

      onButtonClick(event) {
        const button = event.target.closest('button[name="plus"], button[name="minus"]');
        if (!button || !this.input) return;

        event.preventDefault();
        const previousValue = this.input.value;

        if (button.name === 'plus') {
          this.input.stepUp();
        } else {
          this.input.stepDown();
        }

        if (this.input.value !== previousValue) {
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    customElements.define('quantity-input', QuantityInput);
  }

  if (!customElements.get('cart-drawer')) {
    class SvaCartDrawer extends HTMLElement {
      constructor() {
        super();
        this.activeElement = null;
        this.updateTimer = null;

        this.addEventListener('keyup', (event) => {
          if (event.code === 'Escape') this.close();
        });

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        this.bindHeaderCartIcon();
      }

      bindHeaderCartIcon() {
        const icon = document.getElementById('cart-icon-bubble');
        if (!icon || icon.dataset.svaDrawerReady === 'true') return;

        icon.dataset.svaDrawerReady = 'true';
        icon.setAttribute('role', 'button');
        icon.setAttribute('aria-haspopup', 'dialog');
        icon.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(icon);
        });
      }

      onClick(event) {
        if (event.target.closest('#CartDrawer-Overlay, .drawer__close')) {
          event.preventDefault();
          this.close();
          return;
        }

        const removeButton = event.target.closest('cart-remove-button');
        if (!removeButton) return;

        event.preventDefault();
        const line = Number(removeButton.dataset.index);
        if (line) this.updateLine(line, 0);
      }

      onChange(event) {
        const input = event.target.closest('input[name="updates[]"][data-index]');
        if (!input) return;

        window.clearTimeout(this.updateTimer);
        this.updateTimer = window.setTimeout(() => {
          this.updateLine(Number(input.dataset.index), Number(input.value));
        }, 300);
      }

      open(triggeredBy = null) {
        if (triggeredBy) this.activeElement = triggeredBy;

        this.classList.add('animate');
        window.requestAnimationFrame(() => {
          this.classList.add('active');
          document.body.classList.add('overflow-hidden');

          const dialog = this.querySelector('.drawer__inner');
          if (dialog) window.trapFocus(dialog, dialog);
        });
      }

      close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        window.removeTrapFocus(this.activeElement);
      }

      async updateLine(line, quantity) {
        if (!line || Number.isNaN(quantity)) return;

        this.setLoading(true);

        try {
          const response = await fetch(ROUTES.change, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              line,
              quantity,
              sections: CART_SECTIONS,
              sections_url: window.location.pathname,
            }),
          });

          const state = await response.json();
          if (!response.ok || state.errors) {
            throw new Error(typeof state.errors === 'string' ? state.errors : 'No fue posible actualizar el carrito.');
          }

          this.renderContents(state, true);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: state }));
        } catch (error) {
          this.showLineError(line, error.message);
        } finally {
          this.setLoading(false);
        }
      }

      renderContents(state, shouldOpen = true) {
        const drawerHTML = state.sections?.['cart-drawer'];
        if (drawerHTML) {
          const parsed = new DOMParser().parseFromString(drawerHTML, 'text/html');
          const nextDrawer = parsed.querySelector('cart-drawer');

          if (nextDrawer) {
            this.className = nextDrawer.className;
            this.innerHTML = nextDrawer.innerHTML;
          }
        }

        this.renderCartIcon(state.sections?.['cart-icon-bubble']);
        this.bindHeaderCartIcon();

        if (shouldOpen) this.open(this.activeElement);
      }

      renderCartIcon(sectionHTML) {
        if (!sectionHTML) return;

        const current = document.getElementById('cart-icon-bubble');
        const parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
        const next = parsed.getElementById('cart-icon-bubble');

        if (current && next) current.innerHTML = next.innerHTML;
      }

      showLineError(line, message) {
        const error = this.querySelector(`#CartDrawer-LineItemError-${line} .cart-item__error-text`);
        if (error) error.textContent = message;
      }

      setLoading(isLoading) {
        this.classList.toggle('is-loading', isLoading);
        this.querySelectorAll('button, input').forEach((control) => {
          if (isLoading) {
            control.dataset.svaWasDisabled = control.disabled ? 'true' : 'false';
            control.disabled = true;
          } else if (control.dataset.svaWasDisabled === 'false') {
            control.disabled = false;
            delete control.dataset.svaWasDisabled;
          }
        });
      }
    }

    customElements.define('cart-drawer', SvaCartDrawer);
  }

  if (!customElements.get('product-form')) {
    class SvaProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form[data-type="add-to-cart-form"]') || this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"][name="add"]');
        this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.querySelector('.product-form__error-message');

        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      async onSubmit(event) {
        event.preventDefault();
        if (!this.form || !this.submitButton || this.submitButton.disabled) return;

        const variantInput = this.form.querySelector('input[name="id"]');
        if (!variantInput?.value) {
          this.showError('No se pudo identificar la variante del producto.');
          return;
        }

        this.showError();
        this.setLoading(true);

        try {
          const formData = new FormData(this.form);
          formData.set('sections', CART_SECTIONS.join(','));
          formData.set('sections_url', window.location.pathname);

          const response = await fetch(ROUTES.add, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });

          const state = await response.json();
          if (!response.ok || state.status) {
            throw new Error(state.description || state.message || 'No fue posible agregar el producto.');
          }

          if (variantInput.dataset.skipCart === 'true') {
            window.location.href = `${ROOT}checkout`;
            return;
          }

          const drawer = document.querySelector('cart-drawer');
          if (drawer?.renderContents) {
            drawer.activeElement = this.submitButton;
            drawer.renderContents(state, true);
          } else {
            window.location.href = ROUTES.cart;
          }

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: state }));
        } catch (error) {
          this.showError(error.message);
        } finally {
          this.setLoading(false);
        }
      }

      showError(message = '') {
        if (!this.errorWrapper || !this.errorMessage) return;

        this.errorWrapper.toggleAttribute('hidden', !message);
        this.errorMessage.textContent = message;
      }

      setLoading(isLoading) {
        this.submitButton?.classList.toggle('loading', isLoading);
        if (this.submitButton) this.submitButton.disabled = isLoading;

        const spinner = this.querySelector('.loading-overlay__spinner');
        spinner?.classList.toggle('hidden', !isLoading);
      }
    }

    customElements.define('product-form', SvaProductForm);
  }
})();
